import React, { useState } from 'react';
import Table00 from "~/assets/table-00.png";
import Table01 from "~/assets/table-01.png";
import Table02 from "~/assets/table-02.png";
import Table03 from "~/assets/table-03.png";
import "./style.less";

const TABLE_IDS = {
	NONE: "00",
	FIRST: "01",
	SECOND: "02",
	THIRD: "03",
};
const TABLE01_LINES = [
	["Teta Marie", "Teta Anna"].reverse(),
	["Strýc František", "Strýc Standa"].reverse(),
	["Barča B.", "Strýc Milan"].reverse(),
	["Petr B. junior", "Eliška"].reverse(),
	["Radka B.", "Teta Jana"].reverse(),
	["Petr B.", "Babička Jiřina"].reverse(),
	["Zuzka S.", "Babička Staňka"].reverse(),
	["Bratr Kuba", "Verča B."].reverse(),
	["Tamča S.", "Michael V."].reverse(),
	["Sabinka", "Sestra Lejča"].reverse(),
	["Bratr Peťa", "Tatínek Mirek"].reverse(),
	["Babička Marie", "Iva Ú."].reverse(),
];
const TABLE02_LINES = [
	[
		"Tatínek Standa",
		"Maminka Iveta",
		"Ženich",
		"Nevěsta - Martínek",
		"Tatínek Jirka",
		"Maminka Svatka",
	],
];
const TABLE03_LINES = [
	[
		"Martin P.",
		"Lucinka",
		"Petra P.",
		"Martin Č.",
		"Eva Č.",
		"Ruda V.",
		"Lenka V.",
		"Fotograf Marek",
	],
	[
		"Jitka K.",
		"Luboš V.",
		"Verča P.",
		"Radek Z.",
		"Svědkyně Lucka",
		"Svědek Ondra",
		"Lucka M.",
		"Kameraman Jakub",
	],
];

/* eslint-disable react/no-array-index-key */
export default function SeatPage() {
	const [showResponsive, setShowResponsive] = useState(false);
	const [tableClass, setTableClass] = useState(TABLE_IDS.NONE);
	const [bgImg, setBgImg] = useState(Table00);
	const [tableData, setTableData] = useState([]);

	function selectTable(tableId: string) {
		setTableClass(tableId);

		switch (tableId) {
			case TABLE_IDS.FIRST:
				setBgImg(Table01);
				setTableData(TABLE01_LINES);
				break;

			case TABLE_IDS.SECOND:
				setBgImg(Table02);
				setTableData(TABLE02_LINES);
				break;

			case TABLE_IDS.THIRD:
				setBgImg(Table03);
				setTableData(TABLE03_LINES);
				break;

			default:
				setBgImg(Table00);
		}
	}

	function setResponsive() {
		setShowResponsive(!showResponsive);
	}

	return <div className="seatPage">
		<h2 className="seatPage__title">Zasedací pořádek</h2>
		<div>
			<button type="button" className="seatPage__btn" onClick={setResponsive}>Zobrazení pro mobily</button>
		</div>
		{ showResponsive
			? <div>
				<h2 className="seatPage__title">Stůl nevěsty a ženicha</h2>
				<table className="seatPage__seatTable">
					<tbody>
						{TABLE02_LINES.map((tableLine, lineInd) => <tr key={`lineInd${lineInd}`}>
							{tableLine.map((tableCell, cellInd) => <td key={`cellInd${cellInd}`}>
								{tableCell}
							</td>)}
						</tr>)}
					</tbody>
				</table>
				<h2 className="seatPage__title">Protejší stůl pro prodinu</h2>
				<table className="seatPage__seatTable">
					<tbody>
						{TABLE01_LINES.map((tableLine, lineInd) => <tr key={`lineInd${lineInd}`}>
							{tableLine.map((tableCell, cellInd) => <td key={`cellInd${cellInd}`}>
								{tableCell}
							</td>)}
						</tr>)}
					</tbody>
				</table>
				<h2 className="seatPage__title">Vedlejší stůl pro kamarády</h2>
				<table className="seatPage__seatTable">
					<tbody>
						{TABLE03_LINES.map((tableLine, lineInd) => <tr key={`lineInd${lineInd}`}>
							{tableLine.map((tableCell, cellInd) => <td key={`cellInd${cellInd}`}>
								{tableCell}
							</td>)}
						</tr>)}
					</tbody>
				</table>
			</div>
			: <div className="seatPage__tableSelect">
				<img src={bgImg} alt="" className="seatPage__bgImg" />
				<a href="#" onClick={() => selectTable(TABLE_IDS.FIRST)} className="seatPage__areaTable01"></a>
				<a href="#" onClick={() => selectTable(TABLE_IDS.SECOND)} className="seatPage__areaTable02"></a>
				<a href="#" onClick={() => selectTable(TABLE_IDS.THIRD)} className="seatPage__areaTable03"></a>
				<div className={`seatPage__seatTableCont tableId-${tableClass}`}>
					<div className="seatPage__seatTableInner">
						<table className="seatPage__seatTable">
							<tbody>
								{tableData.map((tableLine, lineInd) => <tr key={`lineInd${lineInd}`}>
									{tableLine.map((tableCell, cellInd) => <td key={`cellInd${cellInd}`}>
										{tableCell}
									</td>)}
								</tr>)}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		}
	</div>;
}
